import { css, type Theme } from "@emotion/react";
import { typography, borders } from "aviary-tokens";

import { ellipsesOverflowHelper } from "@styles/emotion-styles/helpers/ellipsesOverflowHelper/ellipsesOverflowHelper";

export const base = (theme: Theme) => css`
  font-size: ${typography.sizeSmall};
  line-height: ${typography.lineHeightSmall};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: 1rem;
  color: ${theme.text.emphasis};
  border-radius: ${borders.radiusBase};
  ${ellipsesOverflowHelper};
`;

export const bold = (theme: Theme) => css`
  font-weight: ${typography.weightSemiBold};
  color: ${theme.text.emphasis};
`;

export const mainCategory = (theme: Theme) => css`
  font-size: ${theme.aviaryTypography.body.fontSize};
  line-height: ${theme.aviaryTypography.body.lineHeight};
  padding: 0.5rem;
  color: ${theme.system.textLabelEmphasis};
  cursor: pointer;
  &:hover {
    background-color: ${theme.system.backgroundMuted};
  }
  &:active {
    background-color: ${theme.system.backgroundMuted};
  }
`;

export const wrapper = css`
  width: 100%;
  padding: 0.75rem 1rem;
`;
